import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { PackageResultCardProps } from '../types/bot.types';
import { AiFillStar } from 'react-icons/ai';
import { FaShuttleVan } from 'react-icons/fa';
import { Button } from 'antd';
import { formatBotPrice } from './formatBotPrice';
import PackageFlightsInfo from './PackageFlightsInfo';
import { formatPackageFlightDateTime } from './packageFlightUtils';

const PackageResultCard: React.FC<PackageResultCardProps> = ({
  hotelName,
  hotelStars,
  mealPlan,
  nights,
  airline,
  departure,
  returnDate,
  totalPrice,
  currency,
  imageUrl,
  transferIncluded,
  flights,
  onSelect,
}) => {
  const t = useSelector((s: RootState) => (s.config.translations as any)?.bot);
  const generalT = useSelector((s: RootState) => (s.config.translations as any)?.general ?? {});

  // dates arrive as unix seconds from the provider (dates.start/end); legacy
  // shapes may already be display strings — render whichever parses.
  const depDisplay =
    formatPackageFlightDateTime(departure)?.slice(0, 5) ?? (typeof departure === 'string' ? departure : '');
  const retDisplay =
    formatPackageFlightDateTime(returnDate)?.slice(0, 5) ?? (typeof returnDate === 'string' ? returnDate : '');

  return (
    <div className="bot-result-card bot-result-card--package">
      {imageUrl && (
        <div className="bot-result-card__image-wrap">
          <img src={imageUrl} alt={hotelName} className="bot-result-card__image" />
        </div>
      )}
      <div className="bot-result-card__body">
        <div className="bot-result-card__name">{hotelName}</div>
        <div className="bot-result-card__stars">
          {Array.from({ length: Math.min(hotelStars, 5) }).map((_, i) => <AiFillStar key={i} color="#f5a623" />)}
        </div>
        <div className="bot-result-card__dates">
          📅 {depDisplay}{retDisplay ? ` → ${retDisplay}` : ''}
          {nights !== undefined ? ` · 🌙 ${nights} ${t?.result?.nights ?? 'nights'}` : ''}
        </div>
        {flights ? (
          <PackageFlightsInfo flights={flights} compact />
        ) : (
          airline && <div className="bot-result-card__meta">✈️ {airline}</div>
        )}
        <div className="bot-result-card__badges">
          {mealPlan && <span className="bot-result-card__badge">{mealPlan}</span>}
          {transferIncluded && (
            <span className="bot-result-card__badge bot-result-card__badge--green">
              <FaShuttleVan /> {t?.result?.transferIncluded ?? 'Transfer included'}
            </span>
          )}
        </div>
      </div>
      <div className="bot-result-card__footer">
        <div className="bot-result-card__price">
          {/* ALP min_price is a per-person "from" price — mirror PackageBoxWithGallery. */}
          <span className="bot-result-card__per-night">{generalT.from ?? 'from'} </span>
          {currency} {formatBotPrice(totalPrice)}
          <span className="bot-result-card__per-night"> {generalT.perPerson ?? '/person'}</span>
        </div>
        <Button size="small" type="primary" className="btn-style-5" onClick={onSelect}>
          {t?.result?.select ?? 'Select'}
        </Button>
      </div>
    </div>
  );
};

export default PackageResultCard;
